const styles = (theme) => ({
  errorContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 150px)',
  },
  headerTitle: {
    color: theme.palette.common.blue400,
    fontSize: theme.typography.fontSize28,
    fontWeight: theme.typography.fontWeightSemiBold,
  },
  mainWrapper: {
    textAlign: 'center',
  },
  notFoundImg: {
    maxWidth: 250,
    width: '100%',
    margin: '0 auto',
  },
  contentWrapper: {
    textAlign: 'center',
    marginBottom: 24,
  },
  title: {
    color: theme.palette.common.blue400,
    fontSize: theme.typography.fontSize20,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: 8,
  },
  subTitle: {
    color: theme.palette.common.grey300,
    fontSize: theme.typography.fontSize15,
    lineHeight: 1.5,
    marginBottom: 8,
  },
  btnWrapper: {},
  backBtn: {
    padding: '20px 80px',
  },
});

export default styles;
